import { FandomAds } from "./core/FandomAds";
import { reportError } from "./helpers/observability";
import { init } from "./init";
import { PerformanceMarkName } from "common-types";

// this line make JSX work in the project
// it sets the jsxRenderer function to the window object as defined in `jsxFactory` in tsconfig.json
import "./helpers/jsx/jsxRenderer";

// This brings Promise.withResolvers to the global scope
import "./helpers/promiseWithResolversPolyfill";

performance.mark(PerformanceMarkName.AE_FIRST_LINE_EXEC);

init()
  .then((plugins) => {
    window.fandomAds = new FandomAds(plugins, window.fandomAds?.cmd);
  })
  .catch(reportError);

/**
 *  it is exported as we could publish types to the package registry and use them in other projects (like UCP)
 *
 *  import { fandomAds } from "ad-engine";
 *
 *  declare let window: Window & { fandomAds?: typeof fandomAds };
 */
export const fandomAds = window.fandomAds;
